var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goBackBox"},[_c('span',{staticClass:"iconClass",on:{"click":function($event){return _vm.handleClick()}}}),_c('span',{staticClass:"titleClass"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }